export enum SocialType {
    Kakao = 'Kakao',
    Naver = 'Naver',
    Google = 'Google',
    Apple = 'Apple',
}